import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetOpenMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setOpen]: (localState: CoreState, openState: boolean) => {
      localState.open = openState;
    },
    [CORE_MUTATIONS_KEYS.setOpenFinished]: (localState: CoreState, openState: boolean) => {
      localState.openFinished = openState;
    }
  };
}
